// extracted by mini-css-extract-plugin
export default {"form-control":"DailyForm_form-control__VGQOn"};